<section class="w-full h-full overflow-auto hide-scroll flex content-start flex-wrap" infiniteScroll
  [infiniteScrollDistance]="1" [scrollWindow]="false" [infiniteScrollThrottle]="1000" (scrolled)="loadMoreBooks()">
  <article class="w-full flex flex-wrap">
    <!-- ? Genre Detail -->
    <div class="w-full flex flex-wrap">
      <header class="w-full p-3 flex flex-wrap relative" [ngStyle]="{ 'background-color': 'white' }" id="header">
        <!-- ? Back Button -->
        <div class="w-2/12 flex items-center">
          <button mat-icon-button class="flex justify-center items-center cursor-pointer" (click)="back()"
            [style.color]="genreInfo.setting?.foregroundColor">
            <span class="icon chevron-right-regular text-lg"></span>
          </button>
        </div>

        <div class="w-8/12 flex items-center" *ngIf="scrolled">
          <!-- ? Genre Title -->
          <h1 [style.color]="genreInfo.setting?.foregroundColor" class="w-full text-base font-medium line-clamp-1">
            {{ genreInfo?.title | replaceTitle }}
            <!-- ? Genre Book Count -->
            <span [style.color]="genreInfo.setting?.foregroundColor" class="text-sm mr-2 text-gray-500"> {{ totalCount |
              number }} کتاب </span>
          </h1>
        </div>

        <!-- ? Title and Books Count -->
        <div *ngIf="!scrolled" class="w-full px-2 mt-3 flex flex-wrap items-center justify-between">
          <!-- ? Genre Title -->
          <h1 [style.color]="genreInfo.setting?.foregroundColor" class="w-full text-base font-medium" id="genre-title">
            {{ genreInfo?.title | replaceTitle }}
          </h1>
          <!-- ? Genre Book Count -->
          <p [style.color]="genreInfo.setting?.foregroundColor" class="text-sm text-gray-500" id="genre-book-count">{{
            totalCount | number }} کتاب</p>
        </div>

        <!-- ? Genre Image -->
        <img class="genre-image" width="130" height="130" loading="lazy"
          onerror="this.src='https://cloud.behkhaan.ir/assets/images/default/default_genre.svg'"
          [src]="genreInfo?.id | image: imageType.genre : true : '.svg'" [alt]="genreInfo?.title | replaceTitle" />
      </header>

      <ng-container *ngIf="!loading; else skeletonTemplate">
        <!-- ? Books List -->
        <main class="w-full flex flex-wrap my-3">
          <!-- <virtual-list class="w-full" (scrollEnd)="loadMoreBooks()"> -->
          <div class="w-full flex flex-wrap" *ngIf="books && books?.length > 0">
            @for (book of books; track $index) {
            <div
              class="w-full sm:w-4/12 md:w-3/12 px-3 py-2 border-b border-gray-100 border-l dark:border-gray-600 hover:shadow-sm">
              <app-behkhaan-book-card [_book]="book"> </app-behkhaan-book-card>
            </div>
            }
          </div>
          <!-- </virtual-list> -->
          <ng-container *ngIf="loadingBooks">
            <div class="w-full my-5 flex justify-center items-center">
              <div class="rounded-full flex justify-center items-center">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </ng-container>
        </main>
      </ng-container>
    </div>
  </article>

  <!-- <article class="left-article">
    <app-home-currently-reading></app-home-currently-reading>
  </article> -->
</section>

<!-- ? Skeleton -->
<ng-template #skeletonTemplate>
  <app-skeleton-behkhaan-book-card class="w-full"></app-skeleton-behkhaan-book-card>
</ng-template>